export default function () {
  this.route("discourse-ai-shared-conversation-show", {
    path: "/discourse-ai/ai-bot/shared-ai-conversations/:share_key",
  });
}
